import { Container, Row, Col, Spinner } from "react-bootstrap";
import "../common.css";

function Loading({ pageImage }) {
  return (
    <Container fluid>
      <Row className="mt-5 " />
      <Row className="mt-5 ">
        <Col
          xs={{ span: 10, offset: 1 }}
          sm={{ span: 8, offset: 2 }}
          md={{ span: 6, offset: 3 }}
        >
          <div className="centered-container">
            <Spinner animation="border"></Spinner>
          </div>
        </Col>
      </Row>
      <div style={{ display: "none" }}>{pageImage}</div>
    </Container>
  );
}

export default Loading;
